import ApiService from "@/services/api"
import { useUserStore } from "../store/user"

export const AuthService = {
  basePath: "/api/v1",

  getJwtToken: async (temporaryCode: string) => {
    const userStore = useUserStore()

    try {
      const resp = await ApiService.get(
        `${AuthService.basePath}/guest-charging/guest-charging-init-data`,
        {},
        { temporaryCode }
      )
      const tokenString = resp.data.jwt
      userStore.setBearerToken(tokenString)
      return resp
    } catch (e) {
      userStore.setBearerToken("")
      throw e
    }
  }
}
